import { useEffect, useState } from 'react';
import { Button, Tooltip } from '@fluentui/react-components';
import { Check, Copy } from 'lucide-react';

// FD-570 — copy an identifier an operator is likely to paste elsewhere (a client id
// into the Entra portal, a tenant id into a ticket). Identifiers only; nothing secret
// is ever rendered next to one of these.
export default function CopyValueButton({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const t = window.setTimeout(() => setCopied(false), 1500);
    return () => window.clearTimeout(t);
  }, [copied]);

  return (
    <Tooltip content={copied ? 'Copied' : `Copy ${label}`} relationship="label">
      <Button
        appearance="subtle"
        size="small"
        icon={
          copied ? <Check size={14} strokeWidth={1.5} /> : <Copy size={14} strokeWidth={1.5} />
        }
        onClick={() => {
          void navigator.clipboard?.writeText(value).then(() => setCopied(true), () => undefined);
        }}
      />
    </Tooltip>
  );
}
